import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=f8ab6f1c&"
import script from "./QuestionHeader.vue?vue&type=script&lang=js&"
export * from "./QuestionHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuestionHeader.vue?vue&type=style&index=0&id=f8ab6f1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports